import { createContext } from 'react';

import {
	attachInstruction,
	extractInstruction,
} from './hitbox';

import {TreeAction} from "./types";
import {TreeDropIndicator} from "./TreeDropIndicator";
import type {TreeSource} from "./TreeSource";


export type TreeContextValue = {
	dispatch: (action: TreeAction) => void;
	uniqueContextId: Symbol;
	getPathToItem: (itemId: string) => string[];
	treeSource?: TreeSource<any>;
};

export const TreeContext = createContext<TreeContextValue>({
	dispatch: () => {},
	uniqueContextId: Symbol('uniqueId'),
	getPathToItem: () => [],
	treeSource: undefined,
});

export type DependencyContext = {
	DropIndicator: typeof TreeDropIndicator;
	attachInstruction: typeof attachInstruction;
	extractInstruction: typeof extractInstruction;
};

export const DependencyContext = createContext<DependencyContext>({
	DropIndicator: TreeDropIndicator,
	attachInstruction: attachInstruction,
	extractInstruction: extractInstruction,
});
